import { APIError } from "src/models/components/errorModel";
import { ComplaintTypes } from "./actionTypes";

export interface ComplaintInitialState {
loading: boolean;
error:APIError | any;
  complaintList: {
    totalRecords: number,
    values: any
  },
message:string;
paginatorCount:number;
complaintDetails:ComplaintFormDetails | null;
complaintData:any;
prefixList:any;
complaintFiles:any;
allComplaintData:any;
}

export interface ComplaintFormDetails {
  id: number
  complaintName: string
  complaintCode: string
  jobPrefix:any;
  complaintPoints:any;
  isDeleted: boolean
}

export interface DcFormDetail {
  dcFormId: number
  defectSkus: string
  quantity: number
  unitPrice: number
  totalPrice: number
  remarks: string
  id: number
  isDeleted: boolean;
}

const initialState: ComplaintInitialState = {
  loading: false,
  error: null,
  complaintList: {
    totalRecords: 0,
    values: []
  },
  message:"",
  paginatorCount:0,
  complaintDetails:null,
  complaintData:[],
  prefixList:[],
  complaintFiles:[],
  allComplaintData:[]
}

const ComplaintReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ComplaintTypes.GET_COMPLAINT_LOADING:
    case ComplaintTypes.GET_COMPLAINT_BY_ID_LOADING:
    case ComplaintTypes.CREATE_COMPLAINT_LOADING:
    case ComplaintTypes.DELETE_COMPLAINT_LOADING:
    case ComplaintTypes.DELETE_COMPLAINT_FILES_LOADING:
        return{
            ...state,
            loading:true,
            message:"",
            error:""
        }
    case ComplaintTypes.GET_COMPLAINT_SUCCESS:
        return{
            ...state,
            loading:false,
            complaintList:{
                totalRecords: action.payload.data.totalCount,
                values: action.payload.data.items
            },
            paginatorCount: action.payload.data.items.length
        }
  
    case ComplaintTypes.GET_COMPLAINT_BY_ID_SUCCESS:
        return{
            ...state,
            loading:false,
            complaintDetails:action.payload.data
        }
    case ComplaintTypes.CREATE_COMPLAINT_SUCCESS:
        return{
            ...state,
            loading:false,
            message:action.payload
        }
    case ComplaintTypes.DELETE_COMPLAINT_SUCCESS:
        return{
            ...state,
            loading:false,
            error:"",
            message:action.undo ? "Complaint Restored Successfully" : "Complaint Deleted Successfully"
        }
    case ComplaintTypes.GET_COMPLAINT_DROPDOWN_SUCCESS:
        
        return{
            ...state,
            loading:false,
            complaintData:action.payload.data
        }
    case ComplaintTypes.CLEAR_COMPLAINT_DROPDOWN:
        
        return{
            ...state,
            loading:false,
            complaintData:[]
        }
    case ComplaintTypes.GET_PREFIX_DROPDOWN_SUCCESS:
        
        return{
            ...state,
            loading:false,
            prefixList:action.payload.data
        }
    case ComplaintTypes.GET_COMPLAINT_FILES_SUCCESS:
        debugger
        return{
            ...state,
            loading:false,
            complaintFiles:action.payload
        }
    case ComplaintTypes.DELETE_COMPLAINT_FILES_SUCCESS:
        return{
            ...state,
            loading:false,
            message:"Document Deleted Successfully"
        }
    case ComplaintTypes.GET_ALL_COMPLAINT_DROPDOWN_SUCCESS:
        return{
            ...state,
            loading:false,
            allComplaintData:action.payload.data
        }
    case ComplaintTypes.CLEAR_MESSAGE:

        return{
            ...state,
            message:"",
            error:"",
            loading:false
        }
    case ComplaintTypes.RESET_MESSAGE:

        return{
            ...state,
            message:"",
            error:"",
            loading:false,
            complaintDetails:null,
            complaintFiles:[],
        }
    case ComplaintTypes.GET_COMPLAINT_FAIL:
    case ComplaintTypes.GET_COMPLAINT_BY_ID_FAIL:
    case ComplaintTypes.CREATE_COMPLAINT_FAIL:
    case ComplaintTypes.DELETE_COMPLAINT_FAIL:
    case ComplaintTypes.DELETE_COMPLAINT_FILES_FAIL:
        return{
            ...state,
            loading:false,
            error: action.payload
        }
    default:
        return{
            ...state
        }
  }
}

export default ComplaintReducer;